import { render } from "./committee.vue?vue&type=template&id=6dd03bb9"
import script from "./committee.vue?vue&type=script&lang=ts"
export * from "./committee.vue?vue&type=script&lang=ts"
script.render = render

export default script